<template>
  <h1>404 Page not found</h1>
  <p>Url <em>{{url}}</em> was not found</p>
</template>

<script>
export default {
  props: ["url"],
};
</script>